"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const chooseLocationContext_1 = require("../chooseLocationContext");
const app_1 = require("app");
const CountryButton = React.forwardRef((props, ref) => {
    const { country, isSelected, countryIndex, setFocusedElementIndex, searchInputRef } = props;
    const { state, dispatch } = (0, chooseLocationContext_1.useChooseLocationContext)();
    const onSelectCountry = (event) => {
        event.stopPropagation();
        dispatch({ type: chooseLocationContext_1.ChooseLocatioActionType.SET_SELECTED_COUNTRY, payload: country });
        if (country.isMultiLanguage) {
            dispatch({ type: chooseLocationContext_1.ChooseLocatioActionType.OPEN_LANGUAGE_MENU });
        }
    };
    const onKeyDown = (event) => {
        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                setFocusedElementIndex(countryIndex - 1);
                if (countryIndex === 0 && searchInputRef.current) {
                    searchInputRef.current.focus();
                }
                break;
            case 'ArrowDown':
                event.preventDefault();
                setFocusedElementIndex(countryIndex + 1);
                if (countryIndex === state.countries.length - 1) {
                    setFocusedElementIndex(0);
                }
                break;
        }
    };
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: (0, app_1.cn)('w-full font-body focus-visible:bg-fill-primary-hovered px-md py-sm md:py-2xs active:bg-fill-primary-pressed hover:bg-fill-primary-hovered flex items-center justify-between rounded-2xl no-underline focus-visible:outline-0', isSelected && 'header-form__select-country--selected font-bold'), onClick: onSelectCountry, "aria-expanded": isSelected, "aria-controls": "headerLanguagesSelect", onKeyDown: onKeyDown, ref: ref, children: country.countryName }));
});
exports.default = CountryButton;
